export const configUrl = 'https://api.synfutures.com/v3/public/common/dapp/config';
